import React from 'react'
import { AreaEditorProps, DashboardAreaKeys } from '../../types'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import DashboardArea from '../DashboardArea'
import { DASHBOARD_EDITOR_SYSTEM_LOG_AND_MAP_AREA_ID } from 'src/Libs/qa/ids'
import { useTypedSelector } from 'src/State/RootReducer'

/**
 * System log and map area for the dashboard editor
 */
const SystemLogAndMapArea: React.FC<AreaEditorProps> = ({ hidden, setHidden, position, getMenuItems, disabled }) => {
  const { t } = useCustomTranslation()
  const userData = useTypedSelector(state => state.user.userData)
  const isUser = userData?.level === 'USER'
  const nameKey = isUser ? 'dashboard.editor.protocol' : 'dashboard.editor.protocol-and-map'

  return (
    <DashboardArea
      areaKey={DashboardAreaKeys.systemLogAndMap}
      name={t(nameKey)}
      hidden={hidden}
      setHidden={setHidden}
      position={position}
      getMenuItems={getMenuItems}
      disabled={disabled}
      dataQa={DASHBOARD_EDITOR_SYSTEM_LOG_AND_MAP_AREA_ID}
    />
  )
}

export default SystemLogAndMapArea
